import type { JSX } from 'react';
import Box from 'carbon-react/esm/components/box';
import Preview from 'carbon-react/esm/components/preview';

const PreviewListComponent = (): JSX.Element => {
  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box pt={3} pb={3} pr={2}>
        <Preview width="40%" />
      </Box>

      {/* Heading */}
      <Box pt={3} pb={3} pr={2}>
        <Preview width="60%" height="32px" />
      </Box>

      {/* Filters */}
      <Box display="flex" flexDirection="column" gap={2} pt={3} pb={3} pr={2}>
        <Box display="flex" gap={2}>
          <Preview width="300px" height="38px" />
          <Preview width="200px" height="38px" />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" gap={2}>
            <Preview width="150px" height="38px" />
            <Preview width="250px" height="38px" />
          </Box>
        </Box>
      </Box>

      {/* Table */}
      <Box pt={3} pb={3} pr={2}>
        <Preview width="60%" height="32px" />
      </Box>
    </Box>
  );
};

export default PreviewListComponent;
